let config = null;

export async function loadAppConfig() {
  const apiURL = process.env.REACT_APP_BACKEND_API_URL.replace("/api", "");
  const res = await fetch(`${apiURL}/confs`);
  config = await res.json();
}

export function getAppConfig() {
  if (!config) {
    throw new Error("Config ainda não carregado.");
  }
  return config;
}
